import { connect } from 'react-redux'

import { mapStateToPlaceOrderDetails } from './mapStateToPlaceOrderDetails'
import { notifyError } from '../actions'

import CheckoutSummary from './CheckoutSummary'

import { formatMoney } from './formatHelpers'


const mapCheckoutSummaryStateToProps = (state) => {
  const summary = state.entities.Summary;
  const format = formatMoney(summary.Currency);
  return {
    summary: [                                       // summary is an array so we can give lines
                                                     // a definite order
      'SubTotal'      , format(summary.SubTotal      || 0),
      'Shipping Total', format(summary.ShippingTotal || 0),
      'Total'         , format(summary.Total         || 0)
    ],
    summaryEndpoint: state.constants.navigation.cartSummaryEndpoint,
    placeOrderDetails: mapStateToPlaceOrderDetails(state),
    cart: state.entities.CartItems
  };
}

const mapCheckoutSummaryDispatchToProps = dispatch => {
  return {
    onGetSummaryError: (diagnosticMessage) => dispatch(notifyError('Got an error while trying to refresh the summary. Please reload the page and try again, or contact customer service', diagnosticMessage))
  }
}

const CheckoutSummaryContainter = connect(mapCheckoutSummaryStateToProps, mapCheckoutSummaryDispatchToProps)(CheckoutSummary)

export default CheckoutSummaryContainter